/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { Dropdown } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import _ from 'lodash';

// variable custom import
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  TableHeaderForNDCDisputesDetails,
  hideColumns,
} from './gridComponents/tablehead';
import {
  getDisputeNdcDetails,
  getUnitConversionDetail,
  handleNDCErrorDetail,
  dispatchDisputeNDCDetails,
  statusType,
} from '../store/actions';
import {
  dispatchSelectedNDCs,
  dispatchSelectedNDCSearch,
  getNdcGrid,
  dispatchGetSingleNDCByMfgId,
  dispatchGetNDCByMfgId,  // Add this import
} from '../../../Maintain/unitConversion/store/actions';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../../Display/NDC/store/action';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  callSearchClaimAPI,
  getClaimTableInfo,
  setSelectedClaim,
  setSelectedClaimMode,
} from '../../../Display/Claim/store/action';

function NDCDisputesDetails() {
  const dispatch = useDispatch();
  const history = useHistory();

  const singleHeaderDetails = useSelector(
    (state) => state.sharedState.DisputesReducer.singleHeaderDetails
  );
  const disputeNdcAllDetails = useSelector(
    (state) => state.sharedState.DisputesReducer.disputeNdcAllDetails
  );
  const singleDisputeNdc = useSelector(
    (state) => state.sharedState.DisputesReducer?.singleDisputeNdc
  );
  const detailErrorMessages = useSelector(
    (state) => state?.sharedState?.DisputesReducer?.ndcDetailErrorMessages
  );
  const statusSelectedType = useSelector(
    (state) => state.sharedState.DisputesReducer.statusSelectedType
  );

  const disputeCodes = useSelector(
    (state) => state?.sharedState?.DisputesReducer?.disputeCodes
  );

  const [loading, setLoading] = React.useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [disputeNDC, setDisputeNDC] = React.useState([]);

  const [statusCheck, setStatusCheck] = React.useState({
    Open: !!(statusSelectedType?.open === true),
    Closed: !!(statusSelectedType?.closed === true),
  });

  // handling date format of table Grid
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(handleNDCErrorDetail([]));
    if (disputeNdcAllDetails?.length > 0) {
      setDisputeNDC(disputeNdcAllDetails);
    } else {
      setDisputeNDC([]);
    }
  }, [disputeNdcAllDetails]);

  React.useEffect(() => {
    if (disputeCodes && disputeCodes?.rebateRecapDisputeCodeVO?.length && disputeNDC?.length > 0) {
      // Group dispute codes by NDC
      const ndcgrouping = Object.groupBy(
        disputeCodes.rebateRecapDisputeCodeVO,
        ({ ndc }) => ndc
      );
      
      // Process each row and add dispute codes
      const processedData = disputeNDC.map((obj) => {
        const matchedndc = ndcgrouping?.[obj?.ndc];
        if (matchedndc && matchedndc.length) {
          // Group by convertedQtr
          const qtrgrouping = Object.groupBy(
            matchedndc,
            ({ convertedQtr }) => convertedQtr
          );
          
          let matchedqtr = qtrgrouping?.[obj?.qtr];
          
          // (quarter format is different)
          if (!matchedqtr || matchedqtr.length === 0) {
            const allQtrs = Object.keys(qtrgrouping);
            if (allQtrs.length > 0) {
              matchedqtr = qtrgrouping[allQtrs[0]];
            }
          }
          
          if (matchedqtr && matchedqtr.length) {
            let dispCd = matchedqtr.map((item) => item.disputeCode);
            dispCd = [...new Set(dispCd)];
            return {
              ...obj,
              dispCd: dispCd.join(', ')
            };
          }
        }
        return obj;
      });
      setDisputeNDC(processedData);
    }
  }, [disputeCodes, disputeNdcAllDetails]);

  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // handle check/uncheck status API call
  const callNDCDisputes = async (value, other) => {
    dispatch(handleNDCErrorDetail([]));
    setLoading(true);
    let status = 'A';

    if (value === true && other === true) {
      status = 'A';
      dispatch(
        statusType({
          open: true,
          closed: true,
        })
      );
    } else if (value === true) {
      status = 'O';
      dispatch(
        statusType({
          open: true,
          closed: false,
        })
      );
    } else if (other === true) {
      status = 'C';
      dispatch(
        statusType({
          open: false,
          closed: true,
        })
      );
    }
    const payload = {
      qtr: singleDisputeNdc.qtr,
      secUserId: singleDisputeNdc.assignedUserID,
      rpc: singleDisputeNdc.rebateProgramCd,
      mfgId: singleDisputeNdc.mfgId,
      status: status,
    };

    const getRes = await dispatch(getDisputeNdcDetails(payload));

    setLoading(false);

    if (!getRes?.payload) {
      dispatch(dispatchDisputeNDCDetails([]));
      setDisputeNDC([]);
    }
  };

  // Go to maintain unit conversion screen
  const goToUnitConversion = async (data) => {
    dispatch(handleNDCErrorDetail([]));
    setLoading(true);
    const result = await dispatch(getUnitConversionDetail({ drugSeqNum: [data.drugSeqNum] }));
    setLoading(false);
    
    // Manually set the header data with merged information
    if (result?.data && result.data?.length > 0) {
      const temp = result.data.map((item, index) => {
        const processedItem = { ...item };
        if (!processedItem.NDC) {
          processedItem.NDC = `${processedItem.labelerCode || ''}-${processedItem.productCode || ''}-${processedItem.packageSize || ''}`;
        }
        processedItem.indexPaginate = index;
        // Merge with row data
        if (index === 0) {
          processedItem.NDC = data.ndc || processedItem.NDC;
          processedItem.drugName = data.drugName || processedItem.drugName;
          processedItem.minClaimDt = data.minClaimDt || processedItem.minClaimDt;
          processedItem.labelerName = data.labelerName || processedItem.labelerName;
        }
        return processedItem;
      });
      
      const res = {
        status: '001',
        data: temp,
      };
      dispatch(dispatchGetNDCByMfgId(res));
      dispatch(dispatchGetSingleNDCByMfgId(temp[0]));
    }
    await dispatch(getNdcGrid({ drugSeqNum: data?.drugSeqNum }));
    await dispatch(dispatchSelectedNDCSearch({ drugSeqNum: data?.drugSeqNum }));
    localStorage.setItem('checkSearchBit', 10);
    if (result.data && result.data?.length > 0) {
      redirectURLLink(
        '/unitConversion-detail',
        'Display Unit Conversion for NDC',
        history,
        dispatch
      );
    } else {
     dispatch(
        handleNDCErrorDetail([
          {
            field: 'NDCsearch',
            errorType: 'noResults',
            message: constantMessageData.MNFC_NDC_ERROR_MSG,
          },
        ])
      );
      window.scrollTo(0, 0);
    }
  };
  // Go to NDC details screen
  const goToNdcDetails = async (data) => {
    dispatch(handleNDCErrorDetail([]));
    const response = await getNDCDetails([
      { ndc: data.ndc, drugName: data.drugName },
    ]);
    if (response) {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(setCurrentNDCDetailsIndex(1));
      dispatch(setCurrentNDCDetailsSelected(response[0],'All'));
      dispatch(setNDCDetails([{ ndc: data.ndc, drugName: data.ndc }]));
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };
  // handing Claims page redirect
  const handleViewDetailsForClaims = async (data) => {
    dispatch(handleNDCErrorDetail([]));
    setLoading(true);
    const resultData = await callSearchClaimAPI({
      rebateProgramCd: singleDisputeNdc.rebateProgramCd,
      searchByNdc: true,
      drugSqnNum: [data.drugSeqNum],
      paidQtr: singleDisputeNdc.qtr,
    });
    dispatch(getClaimTableInfo(true));
    setLoading(false);
    if (resultData && resultData[0]?.claimResultVOList?.length > 0) {
      dispatch(setSelectedClaimMode('display'));
      dispatch(setSelectedClaim(resultData));
      redirectURLLink('/selected-claim', 'Selected Claim', history, dispatch);
    } else {
      dispatch(
        handleNDCErrorDetail([
          {
            field: 'NDCsearch',
            errorType: 'noResults',
            message: constantMessageData.MNFC_NDC_ERROR_MSG,
          },
        ])
      );
      window.scrollTo(0, 0);
    }
  };
  // custom frame component for actions and values on the tablegrid
  const detailsNDCframeworkComponents = {
    IconButtonCell: (cellInfo) => {
      return (
        <div className="tdCell icon-btn-group">
          <Dropdown className="icon-dropdown-container float-right">
            <Dropdown.Toggle className="icon-dropdown" aria-label="export">
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
              >
                <SVGComponent iconName="Icon-export" />
              </OverlayTrigger>
            </Dropdown.Toggle>
            <Dropdown.Menu className="export_dropdown h-auto">
              <Dropdown.Item
                onClick={() => {
                  handleViewDetailsForClaims(cellInfo.data);
                }}
              >
                Go To Claims
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => {
                  goToUnitConversion(cellInfo.data);
                }}
              >
                Go To Maintain Unit Conversion
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      );
    },
    HyperLinkNameRender: (cellInfo) => {
      let name = '';
      if (cellInfo?.colDef?.headerName === 'NDC') {
        name = cellInfo.data.ndc;
      }

      return (
        <div>
          <a
            href="javascript:void()"
            onClick={() => goToNdcDetails(cellInfo.data)}
          >
            {name}
          </a>
        </div>
      );
    },
    FullNameRender: (cellInfo) => {
      let name = '';
      if (cellInfo?.colDef?.headerName === 'Name') {
        name = cellInfo.data.drugName;
      }

      if (name && name.length > 20) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name && `${name.substring(0, 20)}...`}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
     DisputeCodesRender: (cellInfo) => {
      if (cellInfo?.colDef?.headerName === 'Dispute Codes') {
        const disputeCode = 
          cellInfo.data?.dispCd ||
          cellInfo.data?.disputedCd || 
          cellInfo.data?.disputeCd || 
          singleDisputeNdc?.dispCd || 
          '';
        return <div>{disputeCode}</div>;
      }
      return null;
    },
    disputedAmt: (cellInfo) => {
      let isNegativeVal = false;
      if (
        cellInfo?.data?.origUra &&
        cellInfo?.data?.origUra !== 0 &&
        cellInfo?.data?.origUra !== '0'
      ) {
        isNegativeVal = !(
          parseFloat(cellInfo?.data?.origUra?.toString().split('$')[1]) >= 0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div style={{ color: 'red' }}>{`(${cellInfo?.data?.origUra
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.origUra}`}</div>
          )}
        </>
      );
    },
  };

  return (
    <div className="tabs-container" data-testid="dispute-details-id">
      {!fullScreenView && (
        <CustomSeparator parent1="Research" parent2="Disputes Details" />
      )}

      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            detailErrorMessages?.length > 0
              ? _.map(detailErrorMessages, (l) => l.message)
              : []
          ),
        ]}
      />

      <Spinner load={loading} />

      {!fullScreenView && (
        <>
          <Box className="panel custom-fieldset">
            <div className="custom-check">
              <div className="form-wrapper">
                <div className="mui-custom-form input-md">
                  <TextField
                    autoFocus
                    id="rebate-program"
                    label="Rebate Program"
                    fullWidth
                    disabled
                    placeholder=""
                    inputProps={{ id: 'rebate-program' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={
                      singleHeaderDetails?.rebateProgramCd ||
                      singleDisputeNdc?.rebateProgramCd
                    }
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    autoFocus
                    id="qtrrange"
                    label="Qtr Range"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ id: 'qtrrange' }}
                    value={singleDisputeNdc?.qtr}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    autoFocus
                    id="amtunderdispute"
                    label="Amount Under Dispute"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ id: 'amtunderdispute' }}
                    value={singleDisputeNdc?.ccOpenAmt}
                  />
                </div>
              </div>
              <div className="form-wrapper">
                <div className="mui-custom-form input-md">
                  <TextField
                    autoFocus
                    id="NDC"
                    label="Assigned To"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={disputeNdcAllDetails[0]?.assignedUserID}
                  />
                </div>

                <div className="mui-custom-form input-md">
                  <TextField
                    id="lastAction"
                    label="Mfg ID"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={singleDisputeNdc?.mfgId}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  {/* <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="com-tooltip">Tooltip</Tooltip>}
                  > */}
                  <TextField
                    id="responseDue"
                    label="Mfg Name"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={singleDisputeNdc?.corpName}
                  />
                  {/* </OverlayTrigger> */}
                </div>
              </div>
              <div className="form-wrapper">
                <div className="mui-custom-form input-md frr-remove-label-marginLeft">
                  <div
                    className="form-wrapper db"
                  >
                    <FormControlLabel
                      data-testid="checked_open_ia"
                      control={<Checkbox color="primary" className="" />}
                      label="Open"
                      value={statusCheck.Open}
                      checked={statusCheck.Open}
                      onChange={(e) => {
                        setStatusCheck({
                          ...statusCheck,
                          Open: e.target.checked,
                        });

                        callNDCDisputes(e.target.checked, statusCheck.Closed);
                      }}
                    />
                  </div>
                </div>
                <div className="mui-custom-form input-md frr-remove-label-marginLeft">
                  <div
                    className="form-wrapper db"
                  >
                    <FormControlLabel
                      data-testid="checked_closed_ia"
                      control={<Checkbox color="primary" className="" />}
                      label="Closed"
                      value={statusCheck.Closed}
                      checked={statusCheck.Closed}
                      onChange={(e) => {
                        setStatusCheck({
                          ...statusCheck,
                          Closed: e.target.checked,
                        });

                        callNDCDisputes(statusCheck.Open, e.target.checked);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </>
      )}
      <div
        id="testGrid"
        className="panel-body FRR-custom-table tbl-manufacturer-inner ndc-dispute-table"
      >
        <TableGrid
          data-testid="ndc-disputes-table"
          rowSelection="single"
          hideColumnsInPdf={hideColumns}
          rowMultiSelectWithClick={false}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
          rowData={disputeNDC?.map((item) => {
            item.origDispUnits = item.origDispUnits
              ? parseFloat(item.origDispUnits).toFixed(3)
              : parseFloat(0).toFixed(3);
            item.disputedUnits = item.disputedUnits
              ? parseFloat(item.disputedUnits).toFixed(3)
              : parseFloat(0).toFixed(3);
            return item;
          })}
          columnDefs={TableHeaderForNDCDisputesDetails}
          exportFile
          animateRows
          sideBar={false}
          isScrollOn
          fileName="NDC-Disputes-Details"
          singleClickEdit
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          frameworkComponents={detailsNDCframeworkComponents}
        />
      </div>
    </div>
  );
}
export default withRouter(NDCDisputesDetails);
